export let InvoiceStatus;
(function (InvoiceStatus) {
  InvoiceStatus["DRAFT"] = "draft";
  InvoiceStatus["OPEN"] = "open";
  InvoiceStatus["PAID"] = "paid";
  InvoiceStatus["VOIDED"] = "voided";
})(InvoiceStatus || (InvoiceStatus = {}));